import React, { ReactElement, useEffect } from 'react';
import Form from 'react-jsonschema-form';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { JSONSchema6 } from 'json-schema';
import {
  passwordResetRequestError,
  isPasswordResetRequestPending,
  passwordResetRequestSucceeded,
  resetPasswordRequest,
  resetPasswordRequestLoading,
} from '../../dux';

const ForgotPassword = (): ReactElement => {
  const isLoading = useSelector(isPasswordResetRequestPending);
  const requestSuccess = useSelector(passwordResetRequestSucceeded);
  const loadingError = useSelector(passwordResetRequestError);
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch(resetPasswordRequestLoading());
    };
  }, [dispatch]);

  const schema: JSONSchema6 = {
    type: 'object',
    required: ['email'],
    properties: {
      email: {
        type: 'string',
        title: 'Email address associated with account',
        format: 'email',
      },
    },
  };

  const uiSchema = {
    email: {
      'ui:placeholder': 'Enter email address',
    },
  };

  return (
    <div>
      <div>
        <h3 className="text-center mb-5">Forgot Password</h3>
      </div>
      {!isLoading && !requestSuccess && !loadingError && (
        <Form
          formData={{ email: '' }}
          onError={() => {
            console.log('errors');
          }}
          onSubmit={(form) => dispatch(resetPasswordRequest(form.formData.email))}
          schema={schema}
          showErrorList
          uiSchema={uiSchema}
        >
          <div>
            <button
              className="btn btn-primary"
              id="reset-password-button"
              type="submit"
            >
              Reset Password
            </button>
          </div>
          <div className="mt-3">
            <Link to="/login">
              <small>Go to login</small>
            </Link>
          </div>
        </Form>
      )}

      {loadingError && (
        <div className="alert alert-warning">{loadingError.message}</div>
      )}

      {requestSuccess && (
        <div className="alert alert-success">
          Thanks! An e-mail has been sent with a reset link (if an account exists
          matching that e-mail).
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;
